import { UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';

export const sendNotificationMessage = () => {
	const dispatch = useDispatch();

	return useMutationHook(
		[endPointUrls.ADMIN_NOTIFICATIONS_SEND],
		(data: any) => api.post(endPointUrls.ADMIN_NOTIFICATIONS_SEND, data),
		{
			onSuccess: (res) => {
				const response = res as AxiosResponse;

				if (response?.status === 200) {
					toastHandler('success', response?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult;
};
export const sendPrivateNotificationMessage = () => {
	const dispatch = useDispatch();

	return useMutationHook(
		[endPointUrls.ADMIN_NOTIFICATIONS_PRIVATE_SEND],
		(data: any) => api.post(endPointUrls.ADMIN_NOTIFICATIONS_PRIVATE_SEND, data),
		{
			onSuccess: (res) => {
				const response = res as AxiosResponse;

				if (response?.status === 200) {
					toastHandler('success', response?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult;
};
